export default __webpack_public_path__ + "static/media/Aura-Egg__40.7989f5f4.png";